import { render, staticRenderFns } from "./SojaSafra2324Paraguay.vue?vue&type=template&id=33b42af6&lang=pug"
import script from "./SojaSafra2324Paraguay.vue?vue&type=script&lang=js"
export * from "./SojaSafra2324Paraguay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports